/**
 * ModuleMD PatientPortal API
 * ModuleMD PatientPortal API service
 *
 * OpenAPI spec version: 1.0.0
 * Contact: emrsupport@modulemd.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
    HttpClient, HttpHeaders, HttpParams,
    HttpResponse, HttpEvent
} from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';

import { Observable } from 'rxjs/Observable';

import { PatientPortalCreatePassword } from '../model/patientPortalCreatePassword';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { environment } from '../../environments/environment';
import { PasswordDetails } from '../model/models';

@Injectable()
export class UpdatePatientSecurityDetailsService {

    protected basePath = environment.appSetting.apiUrl +'patientportal';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Referenced to SOA.UpdatePatientSecurityDetails
     * This API Updates patient security details
     * @param patient Update patient portal security data
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updatePatientSecurityDetails(patient: PasswordDetails, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public updatePatientSecurityDetails(patient: PasswordDetails, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public updatePatientSecurityDetails(patient: PasswordDetails, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public updatePatientSecurityDetails(patient: PasswordDetails, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        
        if (patient === null || patient === undefined) {
            throw new Error('Required parameter patient was null or undefined when calling updatePatientSecurityDetails.');
        }

        let headers = this.defaultHeaders;
        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        //if (patient.UserName !== undefined && patient.UserName !== null) {
        //    queryParameters = queryParameters.set('userName', <any>patient.UserName);
        //}
        //if (patient.UserEmail !== undefined && patient.UserEmail !== null) {
        //    queryParameters = queryParameters.set('userEmail', <any>patient.UserEmail);
        //}
        // authentication (api_key) required
        if (this.configuration.apiKeys["Context"]) {
            headers = headers.set('Context', this.configuration.apiKeys["Context"]);
        }

        // authentication (idp_auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/CreatePassword`,
            patient,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
